import { AssistantPanel } from '@/components/AssistantPanel';
import { OrbitalDock } from '@/components/OrbitalDock';
import { CinematicScene } from '@/components/CinematicScene';

export default function App() {
  return (
    <div className="relative w-screen h-screen overflow-hidden bg-void">
      <CinematicScene />

      <div className="relative z-10">
        <AssistantPanel />
      </div>

      <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50">
        <OrbitalDock />
      </div>
    </div>
  );
}
